import { StartClient } from '@tanstack/react-start/client';
import { hydrateRoot } from 'react-dom/client';

import { registerServiceWorkerAfterLoad } from './lib/pwa/service-worker';
import { installConsoleGuard } from './lib/utils/consoleGuard';
import { attachPageElasticOverscroll } from './hooks/ui/useElasticOverscroll';

/**
 * Client Entry Point for TanStack Start
 *
 * - Use hydrateRoot for SSR hydration
 * - QueryClientProvider lives in __root.tsx RootDocument (router.tsx sets wrapQueryClient:false)
 *
 * @see https://tanstack.com/start/latest/docs/framework/react/ssr
 */

installConsoleGuard();
// Page-level elastic overscroll cue (wheel past the document ends) on
// platforms without native rubber-band. Runs for the app lifetime.
attachPageElasticOverscroll();

hydrateRoot(document, <StartClient />);
registerServiceWorkerAfterLoad();
